import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';
import { Fragment } from 'react';

export default class AccountFollowing extends React.Component {

  static propTypes = {
    user: UserShape
  }

  render() {
    return (
      <div className='user-sidebar-following sidebar'>
        <ul className='item-meta'>
          <li>
            <Link to={`/people/${this.props.user.get('slug')}/follows`}>
              <b>Following</b>: { this.props.user.get('followsCount') }
            </Link>
          </li>
          <li>
            <Link to={`/people/${this.props.user.get('slug')}/followers`} className='follow-link'>
              <b>Followers</b>: { this.props.user.get('followersCount') }
            </Link>
          </li>
        </ul>
        <p></p>
        <div>
          { this.renderFollowActions() }
        </div>
      </div>
    );
  }

  renderFollowActions() {
    if (this.props.user.get('public')) {
      return (
        <Fragment>
          <div>
            <Link to='/account/recommend_people_to_follow'>Find People to Follow</Link>
          </div>
          <div>
            <Link to={ `/people/${this.props.user.get('slug')}` }>See what Others See</Link>
          </div>
          <div>
            <Link to={ `/account/make_private_profile` }>Turn off Following</Link>
          </div>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <div>
            <Link to='/account/make_profile'>Setup Following</Link>
          </div>
        </Fragment>
      );
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/account_following.jsx